import { Injectable } from '@angular/core';
import { APP_CONFIG, LOGIN_URL } from 'app.config';
import { USER_URL } from 'app/shared/common/constants/Common.constant';
import { HttpHelper } from 'app/shared/common/utils/http/HttpHelper';
@Injectable({
    providedIn: 'root'
})
export class SignInService {
    constructor(private httpHelper: HttpHelper) {

    }

    login(username: string, password: string, remember: boolean = false): Promise<any> {
        const loginObject: any = {
            'username': username,
            'password': password,
            'rememberMe': remember
        };
        return this.httpHelper.methodPostLoginService(LOGIN_URL.LOGIN, loginObject, APP_CONFIG.COMMAND_TIME_OUT);
    }

    getUserInfo(): Promise<any> {
        return this.httpHelper.methodGetService(LOGIN_URL.USER_INFO);
    }

    getCurrentUserApp(): Promise<any> {
        return this.httpHelper.methodGetService(USER_URL.CURRENT_APP);
    }

    logout(username: string): Promise<any> {
        const urlLogout: string = APP_CONFIG.HOST_NAME_LOGIN + APP_CONFIG.LOGOUT_SERVICE,
            params: string = 'username=' + username;
        return this.httpHelper.actionLogOut(urlLogout, APP_CONFIG.COMMAND_TIME_OUT);
    }
}
